const switchSolvvy = (display: 'none' | 'block') => {
    let style = document.querySelector('#solvvy-chat-style');
    if (style) {
        style.remove();
    }
    style = document.createElement('style');
    style.id = 'solvvy-chat-style';
    style.textContent = `
        #solvvy-container { 
            display: ${display};
        }
        #solvvy-ui-iframe {
            min-height: 40vh !important;
        }
    `;
    document.head.appendChild(style);
};

export default switchSolvvy;
